/**
 * Display an order's human-readable number. New orders carry the entity-lettered
 * OC serial (`{L}OC-YYYY-NNNN`: `WOC-`, `SOC-`, `POC-`); `orderNumber === ocNumber`.
 * Legacy `PRJ-` and `ORD-` orders stay as stored. This function only rewrites the
 * legacy `PRJ-` prefix to `ORD-` (Projects→Orders rename, PR3); all other values
 * pass through unchanged. Single source of truth for rendering an order number.
 */
export const displayOrderNumber = (n: string | undefined | null): string =>
  (n ?? '').replace(/^PRJ-/, 'ORD-');
